// extracted by mini-css-extract-plugin
export default {"expandedAccessLogCell":"styles_expandedAccessLogCell__eDXOx"};